// @react-native-aria/overlays doesn't export PlacementAxis
import type { PlacementAxis } from '@react-aria/overlays'

import type { TOverlayPlacement } from './toReactAriaPlacement'

export const getArrowPlacement = (dynamicPlacement: PlacementAxis, placement: TOverlayPlacement) => {
  if (placement.includes('-')) {
    const [, position] = placement.split('-')

    return `${dynamicPlacement}-${position}`
  }

  return dynamicPlacement
}
